import { combineReducers } from 'redux';

import {  OKUPANSI_KUOTA } from '../actions/okupansiKuotaAction';

const FetchDataAll = (state = { isLoad: false, data: { data: {} } }, action) => {
    switch (action.type) {
        case OKUPANSI_KUOTA:
            return { isload: action.load, data: action.data }
        default:
            return state
    }
};

const OkupansiKuotaReducer = combineReducers({
  FetchDataAll,
});

export default OkupansiKuotaReducer;